import * as React from "react";
import { i18n as globalI18n } from "@lingui/core";
import * as LinguiReact from "@lingui/react";

// Many dialogs and sheets render where `useLingui()` would throw: tests
// without an I18nProvider, and tests whose `@lingui/react` mock has no
// LinguiContext. Reading the context directly (through a stand-in when the
// export is missing) keeps the hook unconditional and falls back to the global
// instance, while a real provider still re-renders the label on a locale switch.
const NoLinguiContext = React.createContext<LinguiReact.I18nContext | null>(null);
const LinguiContext =
  "LinguiContext" in LinguiReact ? LinguiReact.LinguiContext : NoLinguiContext;

/** The localised "Close" for the close button of a dialog or a sheet. */
export function useDefaultCloseLabel(): string {
  const i18n = React.useContext(LinguiContext)?.i18n ?? globalI18n;
  return i18n._({ id: "common.close", message: "Close" });
}
